'use client';

import Script from 'next/script';

import { CookieConsentStatus } from '@hub/common/src/analytics-utils';

import { useCookieConsentStatus } from './CookieConsentStatusProvider';
import { useGTMLoadedStatus } from './GTMLoadedStatusProvider';

export default function GoogleAnalyticsLoader() {
  const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID || '';
  const GA_MEASUREMENT_ID = process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID || '';

  if (!GTM_ID || !GA_MEASUREMENT_ID) {
    throw new Error('NEXT_PUBLIC_GTM_ID and NEXT_PUBLIC_GA_MEASUREMENT_ID must be set');
  }

  const { hasConsent, consentLoaded } = useCookieConsentStatus();
  const { setGTMLoaded } = useGTMLoadedStatus();

  const onScriptReady = () => {
    setGTMLoaded(true);
  };

  // don't event initialize google analytics / google tag manager if consent is not loaded or in pending state (cookie banner still open)
  if (!consentLoaded || hasConsent === CookieConsentStatus.PENDING) {
    return null;
  }

  return (
    <>
      {/* initialize google tag manager */}
      <Script
        id='google-tag-manager'
        strategy='afterInteractive'
        dangerouslySetInnerHTML={{
          __html: `
          window.dataLayer = window.dataLayer || [];

          function gtag() {
            dataLayer.push(arguments);
          }

          gtag('consent', 'default', {
            analytics_storage: '${hasConsent === CookieConsentStatus.DENIED ? CookieConsentStatus.DENIED : CookieConsentStatus.GRANTED}',
            ad_storage: '${CookieConsentStatus.DENIED}',
            ad_user_data: '${CookieConsentStatus.DENIED}',
            ad_personalization: '${CookieConsentStatus.DENIED}'
          });

          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({
            'gtm.start': new Date().getTime(),
            event:'gtm.js'
          });var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${GTM_ID}');

          window.dataLayer.push({
          event: 'init_ga',
          mainGaId: '${GA_MEASUREMENT_ID}'
          });
        `
        }}
        onReady={onScriptReady}
      />
    </>
  );
}
